import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { ScanService } from 'src/app/services/scan.service';
import { ChipsModule } from "primeng/chips";
import { FormsModule } from "@angular/forms";
import { ButtonDirective } from "primeng/button";
import { TranAndTraceScan } from 'src/app/domain/Scan';

@Component({
  standalone: true,
  selector: 'app-TrackAndTraceLanding',
  templateUrl: './TrackAndTraceLanding.component.html',
  imports: [CommonModule, TranslateModule, TranslatePipe, ChipsModule, FormsModule, ButtonDirective],
  styleUrls: ['./TrackAndTraceLanding.component.scss']
})
export class TrackAndTraceLandingComponent implements OnInit {
  scans = new Array<TranAndTraceScan>();
  senderCompanyAddrese: any = null;
  SenderShipment:any  = null;
  PictureToShow: string = '';
  FileToShow: string = '';
  trackingNumber: string = '';
  loading = false;
  errorMessage = '';
  IsloggedIn = false;
  OwnerName = "AliceTms";
  isGuid = false;
  Eta?: Date;
  wayBill:string = "00000000";

  constructor(private scanService: ScanService, private route: Router, private auth: AuthService) {

  }

  ngOnInit(): void {
    this.GetTrackingInfomation(this.trackingNumber, true);
    // this.IsloggedIn = this.auth.isAliceAdmin();
  }

  GetTrackingInfomation(trackingNumber: string, useTrackingInput: boolean): void {
    this.loading = true;
    this.errorMessage = '';
    if (useTrackingInput) {
      const urlParts = this.route.url.split('/');
      this.trackingNumber = urlParts[urlParts.length - 1];
      if (this.trackingNumber.split('-').length <= 5) {
        // its a guid
        this.isGuid = true;
      } else
        this.isGuid = false;
      this.OwnerName = urlParts[0] ?? "aliceTms";
    }

    this.scanService.GetShipmentTrackAndTraceInfomationV2(this.trackingNumber).subscribe({
      next: (response: any) => {
        this.senderCompanyAddrese = response?.senderCompanyAddrese;
        this.SenderShipment = response?.senderShipment;
        this.scans = (response?.scans as TranAndTraceScan[]).sort((x, y) => new Date(x.scanDateTime) > new Date(y.scanDateTime) ? -1 : 1);
        this.trackingNumber = response.scans[0]?.trackAndTrace ?? "no trackAndTrace Found";
        this.loading = false;
        this.Eta = response.eta == null || response.eta == undefined  ? null : new Date(response.eta);
        this.wayBill = ((response.scans as TranAndTraceScan[])[0].trackAndTrace ?? "0000000000000000000").substring(0,8);
      },
      error: (error) => {
        console.error('Track and trace load failed', error);
        this.errorMessage = 'Unable to load tracking information.';
        this.loading = false;
      }
    });
  }

  Showpicture(scan: any): void {
    this.PictureToShow = scan.image || scan.Image || '';
    this.FileToShow = '';
  }

  Showfile(scan: any): void {
    this.FileToShow = scan.file || scan.File || '';
    this.PictureToShow = '';

    if (this.FileToShow) {
      window.open(this.FileToShow, '_blank');
    }
  }

  clearPreview(): void {
    this.PictureToShow = '';
    this.FileToShow = '';
  }

  getLatestScan(): any | null {
    return this.scans?.length ? this.scans[0] : null;
  }

  getStatusText(): string {
    const latest = this.getLatestScan();
    const text = (latest?.text || latest?.Text || '').toLowerCase();

    if (text.includes('delivered')) return 'Delivered';
    if (text.includes('out for delivery')) return 'Out for delivery';
    if (text.includes('transit')) return 'In transit';
    if (text.includes('sorting')) return 'Sorting';
    return latest?.text || latest?.Text || 'Shipment update';
  }

  getStatusClass(): string {
    const latest = this.getLatestScan();
    const text = (latest?.text || latest?.Text || '').toLowerCase();

    if (text.includes('delivered')) return 'status-delivered';
    if (text.includes('out for delivery')) return 'status-delivery';
    if (text.includes('failed') || text.includes('exception')) return 'status-error';
    return 'status-transit';
  }

  getScanIcon(scan: any): string {
    const text = (scan?.text || scan?.Text || '').toLowerCase();

    if (text.includes('delivered')) return 'pi pi-check-circle';
    if (text.includes('out for delivery')) return 'pi pi-send';
    if (text.includes('pickup')) return 'pi pi-box';
    if (text.includes('sorting')) return 'pi pi-directions';
    return 'pi pi-clock';
  }
  FindShipment() {
    this.GetTrackingInfomation(this.trackingNumber, false);
  }
}